import {Injectable} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {RemovePushTokenAction, SetPushTokenAction} from './user-notification.actions';
import {UsersService} from "@smatchy/sdk";
import {firstValueFrom} from 'rxjs';
import {LoadUserProfileAction} from './user-profile.actions';

export interface UserNotificationStateModel {
  pushToken: string;
}

const defaults: UserNotificationStateModel = {
  pushToken: ''
};

@State<UserNotificationStateModel>({
  name: 'userNotification',
  defaults
})
@Injectable()
export class UserNotificationState {


  constructor(private readonly _userService: UsersService) {
  }

  @Action(SetPushTokenAction)
  async SetPushTokenAction({patchState, dispatch}: StateContext<UserNotificationStateModel>, {
    pushToken
  }: SetPushTokenAction) {

    if (pushToken !== ' ') {
      await firstValueFrom(this._userService.renewPushToken({
        token: pushToken
      }));
      patchState({
        pushToken
      });
      await firstValueFrom(dispatch(new LoadUserProfileAction()));
    }


  }

  @Action(RemovePushTokenAction)
  async removePushTokenAction({patchState}: StateContext<UserNotificationStateModel>) {
    try {
      await firstValueFrom(this._userService.removePushToken());
    } catch {
      console.log("token has removed");
      
    }
    patchState({pushToken: ''});
  }
}
